// en_pms_housekeeping.ts
// Tłumaczenia dla PMS.Housekeeping.tsx

export const enPmsHousekeeping = {

  title: "Housekeeping",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomControl:   "Room control",
    roomSnapshot:  "Room status",
    tasks:         "Housekeeping tasks",
    maintenance:   "Maintenance and blocking",
    realtimeFeed:  "Live feed",
    operations:    "Operations",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    roomReadiness: "Room readiness, task management, maintenance, blocking and real-time operations.",
    fastUpdates:   "Fast room status updates with safe persistence.",
    currentState:  "Current operational state.",
    createTrack:   "Create and track operational room tasks.",
    escalate:      "Escalate technical faults and protect inventory.",
    prepared:      "Prepared for future event streaming on staff devices.",
  },

  // ── Typy zadań ────────────────────────────────────────────────────────────
  taskTypes: {
    inspection:       "Inspection",
    turndown:         "Turndown",
    deepClean:        "Deep clean",
    maintenanceFollowUp: "Maintenance follow-up",
    taskType:         "Task type",
  },

  // ── Statusy pokoi (specyficzne dla HK) ───────────────────────────────────
  roomStatus: {
    clean:     "Clean",
    dirty:     "Dirty",
    cleaning:  "Cleaning",
    inspected: "Inspected",
    blocked:   "Blocked",
  },

  // ── Konserwacja i blokowanie ──────────────────────────────────────────────
  maintenance: {
    severity:    "Issue severity",
    blockRoom:   "Block room",
    releaseBlock:"Release block",
    resolved:    "Resolved by service, handed over to housekeeping.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    priority:          "Priority",
    housekeepingStatus:"Housekeeping status",
    unassigned:        "Unassigned",
  },

  // ── Komunikaty błędów ─────────────────────────────────────────────────────
  messages: {
    blockFailed:            "Room block failed.",
    blockReleaseFailed:     "Block release failed.",
    maintenanceReportFailed:"Maintenance report failed.",
    maintenanceUpdateFailed:"Maintenance update failed.",
    roomUpdateFailed:       "Room update failed.",
    taskCreationFailed:     "Task creation failed.",
    taskUpdateFailed:       "Task update failed.",
  },

} as const;

export default enPmsHousekeeping;
